import * as React from 'react';
import {getLayout, LayoutSize, onLayoutChange} from "modules/cars/rating/tires/utils/layoutUtils";

export interface DeviceProps {
    mobile?: boolean;
    tablet?: boolean;
    desktop?: boolean;
    exclude?: boolean;
    children?: any
}

export default class extends React.Component<DeviceProps, {size: LayoutSize}> {
    private mounted = false;

    state = {
        size: getLayout()
    };

    public static defaultProps: DeviceProps = {
        mobile: false,
        tablet: false,
        desktop: false,
        exclude: false
    };

    constructor() {
        super();
        onLayoutChange( () => this.mounted && this.setState({
            size: getLayout()
        }))
    }

    componentDidMount() {
        this.mounted = true;

        this.setState({
            size: getLayout()
        });
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    shouldShow = () => {
        switch (this.state.size) {
            case LayoutSize.MOBILE: return this.props.mobile !== this.props.exclude;
            case LayoutSize.TABLET: return this.props.tablet !== this.props.exclude;
            case LayoutSize.DESKTOP: return this.props.desktop !== this.props.exclude;
        }
    };

    render() {
        return this.shouldShow() ? this.props.children : null;
    }
}



// WEBPACK FOOTER //
// ./resources/modules/cars/rating/components/Device.tsx